import date from 'helpers/formatters/date'

// Data (e hora) do envio ou da revisão; valor ausente ou inválido vira "-", nunca "Invalid date".
const formatReviewDateTime = (value, format = 'DD/MM/YYYY [às] HH:mm') =>
  date(value, format) || '-'

export default formatReviewDateTime
